import React, { useState, useCallback, useEffect, useRef } from 'react'
import { LayoutBand, Separator, MarginBox } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { VisuallyHidden } from '@reach/visually-hidden'
import { useTranslation } from 'react-i18next'
import { useLocation, useHistory } from '@fs/zion-router'
import { useTopicContext } from '../../providers/TopicProvider'
import ActivityGroupsGrid from '../../components/ActivityGroupsGrid'
import TempleCountdown from './TempleCountdown'
import { useUserDetailsContext } from '../../providers/UserDetailsProvider'
import useExternalLinks from '../../hooks/useExternalLinks'
import { useGetActivityGroupAnswerCount } from '../../hooks'
import FlyToFeedAnimation from '../../components/FlyToFeedAnimation'

const Temple = () => {
  const { t } = useTranslation()
  const initData = { page_detail: 'Temple' }
  useExternalLinks()
  usePageView(initData)
  const { categories, topicId } = useTopicContext()
  const { templeEligibleDate } = useUserDetailsContext()
  const { activityGroupAnswerCountData } = useGetActivityGroupAnswerCount()
  const location = useLocation()
  const history = useHistory()

  // Read fly-to-feed animation data from location state, then clear it so
  // pressing the browser back button doesn't re-trigger the points animation.
  const flyToFeedDataRef = useRef(location?.state?.flyToFeedData)
  const flyToFeedData = flyToFeedDataRef.current
  const [showFlyToFeed, setShowFlyToFeed] = useState(!!flyToFeedData)
  useEffect(() => {
    if (flyToFeedData) {
      history.replace({ ...location, state: { ...location.state, flyToFeedData: undefined } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFlyToFeedComplete = useCallback(() => {
    setShowFlyToFeed(false)
  }, [])

  return (
    <>
      {showFlyToFeed && flyToFeedData && (
        <FlyToFeedAnimation {...flyToFeedData} onAnimationComplete={handleFlyToFeedComplete} />
      )}
      <LayoutBand>
        <VisuallyHidden>
          <h1>{t('nav.temple', 'Temple')}</h1>
        </VisuallyHidden>
        <MarginBox marginY="md">
          <TempleCountdown templeEligibleDate={templeEligibleDate} />
          <ActivityGroupsGrid categories={categories} topicId={topicId} answerCounts={activityGroupAnswerCountData} />
          <Separator />
        </MarginBox>
      </LayoutBand>
    </>
  )
}

export default Temple
